// extracted by mini-css-extract-plugin
export var logo = "_kv-2";
export var logoWrapper = "_kv-1";
export var strip = "_kv-0";